'use strict';

var util = require('../../util/property-util');
var nocUtil = require('../../util/noc-util');
var graphUtil = require('../../util/graph-util');
var messageDiscriptors = require('../../util/messageDiscriptors');

module.exports = /*@ngInject*/ ["MessageDataFactory", "MessageDataQueryFactory", "ChartFactory", "HighChartFactory", "$filter", function (MessageDataFactory, MessageDataQueryFactory, ChartFactory, HighChartFactory, $filter) {
    function VuFactory() {
    }

    VuFactory.prototype.getVuMessageData = function (vuFilterData, trainInfo, callback) {
        if (!util.isDefined(vuFilterData)) {
            MessageDataFactory.getMessageData("virtualUser", MessageDataQueryFactory.createMessageDataQuery(trainInfo, 1), function (data) {
                callback(data, true);
            });
        }
        else {
            callback(vuFilterData, false);
        }

    };

    VuFactory.prototype.getParsedUrls = function (data) {
        var vuSites = [];
        var allSelectEntry = 'All';
        vuSites.push(allSelectEntry);
        data.forEach(function (entry) {
            entry.timestamp2 = $filter('date')(entry.timestamp, 'd-M-yy h:m');

            var site;
            if (nocUtil.isSubstringEqualTo(entry.testSite, 0, 3, 'www')) {
                site = entry.testSite.substring(4, entry.testSite.length);
            }

            if (nocUtil.isSubstringEqualTo(entry.testSite, 0, 5, 'https')) {
                site = entry.testSite.substring(8, entry.testSite.length);
            }

            if (nocUtil.isSubstringEqualTo(entry.testSite, 0, 5, 'http:')) {
                site = entry.testSite.substring(7, entry.testSite.length);
            }

            if (nocUtil.isSubstringEqualTo(entry.testSite, 0, 14, 'noc.21net.com/')) {
                site = entry.testSite.substring(14, entry.testSite.length);
            }

            if (vuSites.indexOf(site) == -1) {
                vuSites.push(site);
            }
        });
        return vuSites;
    };

    var generateSeriesId = function (messageName, messageStructure, property) {
        "use strict";
        var serieId = property.label;
        var discriminator;
        if (messageStructure.hasDiscriminator(messageName)) {
            if (messageStructure.hasSubDiscriminator(messageName)) {
                discriminator = messageStructure.getDiscriminator(messageName, property.discriminatorName);
                serieId = discriminator.subDiscriminatorLabel + " " + property.subDiscriminatorName + " " + property.label;
            } else {
                discriminator = messageStructure.getDiscriminator(messageName, property.discriminatorName);
                serieId = discriminator.label + " " + property.label;
            }
        }

        return serieId;
    };
    VuFactory.prototype.createVuSeries = function (chart, messageName, selectedProperties, messageStructure) {
        "use strict";
        var seriesIds = [];
        selectedProperties.forEach(function (property) {
            var seriesId = generateSeriesId(messageName, messageStructure, property);
            seriesIds.push(seriesId);

            var isExistingSeries = util.isDefined(graphUtil.findSeries(chart.series, seriesId));

            if (!isExistingSeries) {
                var axisType = property.axis;
                var axis = chart.get(axisType);
                var metaData = messageDiscriptors.getAxisMetaByType(axisType);
                if (util.isDefined(axis)) {
                    if (axis.options.labelsEnabled) {
                        axis.update(
                            {
                                labels: {
                                    enabled: true
                                }
                            }, false
                        );
                    }
                    var seriesObject = undefined;
                    if (property.name == "totalTime") {
                        seriesObject = HighChartFactory.createSeries([], axis, seriesId, metaData.formatFunction, property);
                        seriesObject.marker = {radius: 3, enabled: true};
                    }
                    else {
                        seriesObject = HighChartFactory.createColumnSeries([], axis, seriesId, metaData.formatFunction, property);
                    }
                    seriesObject.dataGrouping = {
                        enabled: false
                    };
                    if (util.isDefined(seriesObject)) {
                        chart.addSeries(seriesObject, false, false);
                    }
                }
            }
        });
        return seriesIds;
    };

    VuFactory.prototype.filterCodeStatistics = function (vuData) {
        var codes = [];
        angular.forEach(vuData, function (vu) {
            var index = util.getIndex(codes, 'code', vu.curlResponseCode);
            //code was not yet added in the list, index returned -1
            if (index == -1) {
                codes.push({'code': vu.curlResponseCode, 'count': 1});
            } else {
                //code was already added in the list, count the amount of times.
                var value = codes[index];
                if (util.isDefined(value)) {
                    value.count++;
                }
            }
        });

        angular.forEach(codes, function (curlResponse) {
            curlResponse.percentage = vuData.length != 0 ? (curlResponse.count / vuData.length) * 100 : 0;
            curlResponse.message = nocUtil.getCurlMessage(curlResponse.code);
        });

        return codes;
    };


    VuFactory.prototype.filterData = function (data, site, responseCode, minTime, maxTime, showAll) {
        var filtered = [];

        if (!angular.isDefined(site) || showAll || !angular.isDefined(responseCode)) {
            return data;
        }
        var criteria = 3;
        angular.forEach(data, function (value) {
            var count = 0;
            if (value.testSite.indexOf(site) != -1 || site == 'All') {
                count++;
            }

            if (value.curlResponseCode == responseCode || responseCode == -1 || responseCode == 'all') {
                count++;
            }

            if (value.totalTime <= maxTime && value.totalTime >= minTime) {
                count++;
            }

            if (count == criteria) {
                filtered.push(value);
            }
        });

        return filtered;
    };

    VuFactory.prototype.calculateVUStatistics = function (vuData) {
        var dnsTimes = [];
        var connectTimes = [];
        var applicationConnectTimes = [];
        var preTransferTimes = [];
        var redirectTimes = [];
        var totalTimes = [];

        if (util.isDefined(vuData)) {
            angular.forEach(vuData, function (vu) {
                dnsTimes.push(vu['dnsTime']);
                connectTimes.push(vu['connectTime']);
                applicationConnectTimes.push(vu['applicationConnectTime']);
                preTransferTimes.push(vu['preTransferTime']);
                redirectTimes.push(vu['redirectTime']);
                totalTimes.push(vu['totalTime']);
            });

            return {
                'dnsTimeAvg': dnsTimes.mean(),
                'connectTimeAvg': connectTimes.mean(),
                'applicationConnectTimeAvg': applicationConnectTimes.mean(),
                'preTransferTimeAvg': preTransferTimes.mean(),
                'redirectTimeAvg': redirectTimes.mean(),
                'totalTimeAvg': totalTimes.mean(),
                'dnsTimeMin': dnsTimes.min(),
                'connectTimeMin': connectTimes.min(),
                'applicationConnectTimeMin': applicationConnectTimes.min(),
                'preTransferTimeMin': preTransferTimes.min(),
                'redirectTimeMin': redirectTimes.min(),
                'totalTimeMin': totalTimes.min(),
                'dnsTimeMax': dnsTimes.max(),
                'connectTimeMax': connectTimes.max(),
                'applicationConnectTimeMax': applicationConnectTimes.max(),
                'preTransferTimeMax': preTransferTimes.max(),
                'redirectTimeMax': redirectTimes.max(),
                'totalTimeMax': totalTimes.max(),
                'dnsTimeStd': dnsTimes.stdDev(),
                'connectTimeStd': connectTimes.stdDev(),
                'applicationConnectTimeStd': applicationConnectTimes.stdDev(),
                'preTransferTimeStd': preTransferTimes.stdDev(),
                'redirectTimeStd': redirectTimes.stdDev(),
                'totalTimeStd': totalTimes.stdDev()
            }
        }
    };

    return new VuFactory();
}];